import { render, staticRenderFns } from "./Rise.vue?vue&type=template&id=72a7c453&"
import script from "./Rise.vue?vue&type=script&lang=js&"
export * from "./Rise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports